import { AfterContentInit, Component, ElementRef, inject, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { from } from 'rxjs';
import { OrderLine } from 'src/app/models/order.model';
import { Good } from 'src/app/models/sync.model';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { CurrentOrderService } from 'src/app/services/data/current-order.service';
import { CurrentRefundService } from 'src/app/services/data/current-refund.service';
import { DbService } from 'src/app/services/data/idb.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';



@Component({
  selector: 'app-quantity-dialog-plain',
  templateUrl: './quantity-dialog.component.html',
  styleUrls: ['./quantity-dialog.component.scss']
})
export class QuantityDialogPlainComponent implements OnInit, AfterContentInit {

  @ViewChild('quantityInput') quantityInput!: ElementRef;
  private readonly currentOrder = inject(CurrentOrderService)
  private readonly currentRefund = inject(CurrentRefundService)
  isAdmin!: boolean
  showDisc = false
  good: Good
  quantity = 0
  price = 0
  promotionCode = ''
  manualEdit = false
  focus = false
  ignoreMinPart = false
  hasBlock = false
  blockRatio = 0

  db: DbService
  constructor(
    public dialogRef: MatDialogRef<QuantityDialogPlainComponent>,
    //public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: QuantityDialogData,
    cm: ConnectionManagerService,
    settingsService: AppSettingsService
  ) {
    this.good = {} as Good
    this.good.code = data.line.goodId
    this.good.ratioPackage = 0
    this.good.minPart = 0
    this.price = this.data.line.price
    this.promotionCode = this.data.line.promotionCode
    this.db = cm.getCurrentDb()
    this.focus = settingsService.focusQuantity
    this.ignoreMinPart = data.ignoreMinPart
    this.good.barcodes = []
  }

  manual() {
    this.manualEdit = true
  }

  ngOnInit(): void {

    const prom = this.db.get('goods', this.data.line.goodId)
    from(prom).subscribe(g => {
      if (!g) return
      this.good = g

      if (this.good.stateId) {
        const state = this.db.goodStates.find(a => a.id == this.good.stateId)
        if (state) {
          this.good.stateColor = state.color
        }
      }
    }
    )

    this.quantity = this.data.line.amount ?? 0
  }



  ngAfterContentInit(): void {
    if (this.focus) {
      setTimeout(() => {
        this.quantityInput.nativeElement.focus()
      }, 200);
    }
  }

  quantityChange(event: any) {
    if (this.good.measure === "шт") {
      this.quantity = Number.parseInt(event.target.value)
    } else { // кг
      this.quantity = pround(Number.parseFloat(event.target.value),3)
    }

    if (Number.isNaN(this.quantity)) {
      this.quantity = 0
    }
  }

  public onSend(): void {

    if (!this.quantity || this.quantity < this.good.minPart && !this.ignoreMinPart) {
      return
    }

    this.data.ok = true
    if (this.good && this.good !== undefined && this.good.prices && Object.keys(this.good.prices).length > 0) {
      this.data.line.price = this.price
      this.data.line.amount = this.quantity
      this.data.line.promotionCode = this.promotionCode
    }

    this.dialogRef.close(this.data);

  }

  add(amount: number) {
    this.quantity = pround(this.quantity + amount,3)

    if (!this.quantity || this.quantity < 0) {
      this.quantity = 0
    }

  }

  addBox(toFull = false) {

    if (!this.quantity) {
      this.quantity = 0
    }


    if (toFull && this.quantity % this.good.ratioPackage !== 0) {
      this.add(this.good.ratioPackage - this.quantity % this.good.ratioPackage)
    } else {
      this.add(this.good.ratioPackage)
    }

  }

    addBlock(toFull = false) {

    if (!this.quantity) {
      this.quantity = 0
    }

    if (toFull && this.quantity % this.blockRatio !== 0) {
      this.add(this.blockRatio - this.quantity % this.blockRatio)
    } else {
      this.add(this.blockRatio)
    }

  }

    removeBlock() {
    if (!this.quantity) {
      this.quantity = 0
    }

    this.add(-this.blockRatio)

  }

  removeBox() {
    if (!this.quantity) {
      this.quantity = 0
    }

    this.add(-this.good.ratioPackage)

  }



  well(): boolean {
    if (this.good.ratioPackage < 2) return true

    if(this.good.barcodes !== undefined){
      this.good.barcodes.forEach(element => {
      if(element.measure.startsWith("бл") && element.ratio !== this.good.quantum){
        this.hasBlock = true
        this.blockRatio = element.ratio  
      } 
    });
    }

    if (!this.quantity) return true
    const t = this.quantity % this.good.ratioPackage;
    const r = t === 0;
    return r;

  }


  goodRatioLabel() {

    if (this.good.measure === "кг") {
      return ` ${this.quantity} ${this.good.measure}.`
    }

    const base = Math.trunc((this.quantity ?? 0) / (this.good.ratioPackage));
    if (this.good.measureBase !== this.good.measure) {
      return `${base} ${this.good.measureBase} x ${this.good.ratioPackage} ${this.good.measure}.`
    } else {
      return ` ${this.quantity} ${this.good.measure}.`
    }
  }

  badRatioLabel() {

    if (this.good.measure === "кг") {
      return ` ${this.quantity} ${this.good.measure}.`
    }

    if (this.good.measureBase !== this.good.measure) {
      return `${Math.trunc((this.quantity ?? 0) / (this.good.ratioPackage))} ${this.good.measureBase} x ${this.good.ratioPackage} + ${Math.trunc((this.quantity ?? 0) % (this.good.ratioPackage))} ${this.good.measure}.`
    } else {
      return ` ${this.quantity} ${this.good.measure}.`
    }
  }

    public deleteItem(): void {
      if(!this.data.line.goodId) return
    if(this.data.isOrder){
      this.currentOrder.deleteItem(this.data.line.goodId)
      
    }
    else{
      this.currentRefund.deleteItem(this.data.line.goodId)
    }
    this.dialogRef.close()
  }

}


export interface QuantityDialogData {
  line: OrderLine
  ignoreMinPart: boolean
  ok: boolean
  canDeleteItem: boolean
  isOrder: boolean
}

function pround(x: number, n = 3) {
  const exp = Math.pow(10, Number(n));
  return Math.round((x + Number.EPSILON) * exp) / exp;
}
